module.exports = __webpack_public_path__ + "static/media/xero_connect_btn.82deffca.svg";